import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    info: {},
  },
  mutations: {
    setUserInfo(state, info) {
      state.info = info
      console.log(state.info)
    }
  },
  actions: {
  },
  modules: {
  }
})
